import Loader from "Components/Loading/Loader/Loader";
import AuditTemplatePageConstants from "Constants/AuditTemplatePageConstants";
import { AuditTemplate } from "Models/Audit/AuditTemplate";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import * as React from "react";
import InfiniteScroll from "react-infinite-scroller";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IAuditTemplateAction } from "Store/AuditTemplates/AuditTemplateAction";
import { AuditTemplateFilterState } from "Store/AuditTemplates/AuditTemplateFilterState";
import { IApplicationState } from "Store/Store";
import i18n from "Translations/i18n";
import AuditTemplateBlockCard from "./AuditTemplateBlockCard/AuditTemplateBlockCard";
import styles from "./AuditTemplateBlockView.scss";

const auditTemplateAction = ServiceProvider.get<IAuditTemplateAction>(Types.IAuditTemplateAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getAuditTemplatesByFilterAsync: (filter: TemplateFilter) =>
        dispatch(auditTemplateAction.getAuditTemplatesByFilterAsync(filter)),
});

const mapStateToProps = (state: IApplicationState) => ({
    isLoading: state.auditTemplateState.isLoading,
    totalAudits: state.auditTemplateState.totalAudits,
    auditTemplates: state.auditTemplateState.auditTemplates,
    currentFilter: state.auditTemplateState.currentFilter,
    skip: (state.auditTemplateState.currentFilter && state.auditTemplateState.currentFilter.skip) || 0
});

interface IProps {
    isLoading: boolean;
    totalAudits?: number;
    auditTemplates?: AuditTemplate[];
    currentFilter: AuditTemplateFilterState;
    skip: number;
    getAuditTemplatesByFilterAsync: (filter: TemplateFilter) => Action;
}

export class AuditTemplateBlockView extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.loadMore = this.loadMore.bind(this);
    }

    public componentDidMount() {
        this.loadAuditTemplates(0);
    }

    private loadAuditTemplates(skip: number) {
        const filter = {
            ...this.props.currentFilter,
            skip,
            take: AuditTemplatePageConstants.BLOCK_ITEMS_PER_PAGE
        };
        this.props.getAuditTemplatesByFilterAsync(filter);
    }

    public loadMore() {
        if (!this.props.isLoading) {
            const skip = this.props.skip;
            const totalAudits = this.props.totalAudits;
            const itemsOnPage = this.props.auditTemplates!.length;
    
            if (skip + AuditTemplatePageConstants.BLOCK_ITEMS_PER_PAGE < totalAudits! && skip < itemsOnPage) {
                const newSkip = skip + AuditTemplatePageConstants.BLOCK_ITEMS_PER_PAGE;
    
                if (newSkip !== skip) {
                    this.loadAuditTemplates(newSkip);
                }
            }
        }
    }

    public render() {
        return (
            <div className={styles.auditTemplateBlockView}>
                {
                    (this.props.auditTemplates && this.props.totalAudits) ? (
                        <InfiniteScroll
                            id="infiniteScroll"
                            pageStart={0}
                            loadMore={this.loadMore}
                            hasMore={this.props.totalAudits > this.props.auditTemplates.length}
                            loader={<div className="loader" key={0}>Loading ...</div>}>
                            <div className={styles.overviewHeader}>
                                <div className={styles.numResults}>{this.props.totalAudits} results</div>
                            </div>
                            <div className={styles.list}>
                                {this.props.auditTemplates.map(auditTemplate => <AuditTemplateBlockCard key={auditTemplate.id} auditTemplate={auditTemplate} />)}
                            </div>
                        </InfiniteScroll>
                    ) : (this.props.isLoading) ? (<Loader />) : (<span>{i18n.t("audits.noAuditsFound")}</span>)
                }
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuditTemplateBlockView);


// WEBPACK FOOTER //
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateBlockView/AuditTemplateBlockView.tsx